//rbac
import { AbilityBuilder } from '@casl/ability';

// export const permissionsArray = ['read', 'create', 'update', 'delete', 'read_all', 'attach', 'detach']
const createAbilitiesFromBinaryString = (binaryString, moduleName, permissionArray) => {
  const { can, build, rules } = new AbilityBuilder();
  if (permissionArray) {
    for (let i = 0; i < binaryString.length; i++) {
      if (binaryString[i] === '1') {
        can(permissionArray[i], moduleName);
      }
    }
  }
  return rules;
};
export default createAbilitiesFromBinaryString;
